import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import {
	FieldShell,
	fieldClassName,
	fieldErrorClassName,
	fieldId,
} from "@/components/ui/field";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
	error?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ className, label, error, id, ...props }, ref) => {
		const textareaId = fieldId(id, label);

		return (
			<FieldShell id={textareaId} label={label} error={error}>
				<textarea
					id={textareaId}
					className={cn(
						fieldClassName,
						error && fieldErrorClassName,
						className,
					)}
					ref={ref}
					{...props}
				/>
			</FieldShell>
		);
	},
);

Textarea.displayName = "Textarea";

export { Textarea };
